// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64068fd6","453":"5e38edf2","455":"5f4cdf41","977":"07d94ebc"}[chunkId] + ".chunk.js";
};